import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_2 from '@/app/ui/assets/svg/plus-active.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 font-montserrat mt-2 md:mt-0 lg:mt-0 xl:mt-0 xxl:mt-0" }
const _hoisted_2 = { class: "flex flex-row my-4" }
const _hoisted_3 = { class: "font-semibold text-14px lg:text-20px xl:text-20px xxl:text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 0,
  class: "inline-flex"
}
const _hoisted_5 = { class: "text-white bg-gray-lp-600 px-6 lg:px-8 xl:px-8 xxl:px-8 text-12px xxl:text-14px py-1.5 lg:py-2 xl:py-2 xxl:py-3 font-bold rounded-md focus:outline-none gap-x-2 justify-center items-center" }
const _hoisted_6 = {
  key: 1,
  class: "inline-flex"
}
const _hoisted_7 = { class: "flex flex-row h-screen py-6 pb-24 overflow-y-auto" }
const _hoisted_8 = { class: "w-full px-4 pb-8 text-12px xxl:text-14px" }
const _hoisted_9 = { class: "flex flex-col w-full md:flex-row mt-6" }
const _hoisted_10 = { class: "py-3 w-full md:w-1/3 mr-4" }
const _hoisted_11 = { class: "py-3 w-full md:w-1/3 mr-4" }
const _hoisted_12 = { class: "w-full mr-4" }
const _hoisted_13 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_15 = { class: "py-3 w-full md:w-1/3 mr-4" }
const _hoisted_16 = { class: "py-3 w-full md:w-1/3" }
const _hoisted_17 = { class: "w-full flex flex-row justify-between items-center" }
const _hoisted_18 = { class: "flex flex-row ml-1" }
const _hoisted_19 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_20 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_21 = { class: "flex flex-row ml-1" }
const _hoisted_22 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_23 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_24 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_25 = { class: "mt-6 rounded-xl bg-white p-3" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_28 = { class: "flex flex-col w-full md:flex-row mt-6" }
const _hoisted_29 = { class: "py-3 w-full md:w-1/2 mr-4" }
const _hoisted_30 = { class: "py-3 w-full md:w-1/4 mr-4" }
const _hoisted_31 = { class: "py-3 w-full md:w-1/4" }
const _hoisted_32 = {
  key: 1,
  class: "w-full text-12px xxl:text-14px"
}
const _hoisted_33 = { class: "flex flex-col gap-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "h-4 w-4",
  alt: "plus"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SavedPackageForm = _resolveComponent("SavedPackageForm")!
  const _component_SavedPackageRow = _resolveComponent("SavedPackageRow")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "w-5 mr-3 cursor-pointer",
          alt: "back"
        }),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ]),
      (!_ctx.isFormValid)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("button", _hoisted_5, [
              _createVNode(_component_Icons, {
                name: "save",
                class: "mr-1"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("managementCustomer.save")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isFormValid)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_lp_button, {
              class: "whitespace-nowrap px-6",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx._onAdd())),
              title: _ctx.$t('managementCustomer.save'),
              textColor: "white",
              iconV2: "",
              iconLeft: "save",
              disabled: _ctx.isErrorForm || _ctx.isSubmitLoading
            }, null, 8, ["title", "disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_Title, {
          label: _ctx.$t('managementCustomer.form.detailInfo')
        }, null, 8, ["label"]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('managementCustomer.form.name'),
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: _ctx.$t('managementCustomer.placeholder.name'),
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.name = $event)),
                  onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setFieldIndex(1))),
                  error: _ctx.errorMandatory[0] && _ctx.errorName,
                  errorCaption: _ctx.errorName
                }, null, 8, ["placeholder", "modelValue", "error", "errorCaption"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('managementCustomer.form.phone'),
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectPhoneCountry, {
                    column: "PhoneNumber",
                    phone: _ctx.phoneNumber,
                    code: _ctx.phoneNumberCode,
                    error: _ctx.errorPhoneSender,
                    customErrorMandatory: 
                  _ctx.$t('managementCustomer.validation.phoneRequired')
                ,
                    onSetPhone: _ctx.setPhoneNumber,
                    onSetPhoneCode: _ctx.setPhoneCodeNumber,
                    onSetErrorPhoneCode: _ctx.setErrorPhoneNumberCode,
                    onSetFieldIndex: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setFieldIndex(2)))
                  }, null, 8, ["phone", "code", "error", "customErrorMandatory", "onSetPhone", "onSetPhoneCode", "onSetErrorPhoneCode"])
                ]),
                _: 1
              }, 8, ["label"]),
              _withDirectives(_createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.errorPhoneSender.message), 1)
              ], 512), [
                [_vShow, 
                _ctx.phoneNumber &&
                  !_ctx.errorPhoneSender.errorPhone &&
                  !_ctx.errorPhoneSender.errorPhoneCode &&
                  _ctx.errorPhoneSender.message
              ]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('managementCustomer.form.email'),
              fontSize: 14,
              optional: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: "e.g. name@email.com",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.email = $event)),
                  error: _ctx.error.email,
                  errorCaption: _ctx.$t('managementCustomer.validation.emailInvalid'),
                  onChange: _ctx.validateEmail,
                  onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setFieldIndex(3)))
                }, null, 8, ["modelValue", "error", "errorCaption", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('managementCustomer.form.commodity'),
              suffix: _ctx.$t('managementCustomer.optionalLabel'),
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  id: "select-search_komoditas_tambah-pelanggan",
                  class: "mt-1.5",
                  options: _ctx.commodities,
                  isLoading: _ctx.isLoadingCommodity,
                  onFilter: _ctx.fetchCommodityList,
                  keyName: "name",
                  keyValue: "code",
                  placeholder: _ctx.$t('managementCustomer.placeholder.commodity'),
                  modelValue: _ctx.commodity,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.commodity = $event)),
                  isShowErrorMessage: false,
                  maxHeight: "270px",
                  onFocus: _cache[9] || (_cache[9] = 
                () => {
                  _ctx.getCommodityList();
                  _ctx.setFieldIndex(4);
                }
              ),
                  useInfiniteScroll: "",
                  onScrolled: _ctx.fetchCommodityListInfiniteScroll,
                  autoUpDown: ""
                }, {
                  "custom-option": _withCtx(({ item }) => [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("div", null, _toDisplayString(item.name), 1),
                      _createVNode("div", _hoisted_18, [
                        (item.isQuarantine)
                          ? (_openBlock(), _createBlock("span", _hoisted_19, " K "))
                          : _createCommentVNode("", true),
                        (item.isDangerousGoods)
                          ? (_openBlock(), _createBlock("span", _hoisted_20, " DG "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  "selected-info": _withCtx(({ selected }) => [
                    _createVNode("div", _hoisted_21, [
                      (selected && selected.isQuarantine)
                        ? (_openBlock(), _createBlock("span", _hoisted_22, " K "))
                        : _createCommentVNode("", true),
                      (selected && selected.isDangerousGoods)
                        ? (_openBlock(), _createBlock("span", _hoisted_23, " DG "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["options", "isLoading", "onFilter", "placeholder", "modelValue", "onScrolled"])
              ]),
              _: 1
            }, 8, ["label", "suffix"])
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('managementCustomer.form.note'),
            suffix: _ctx.$t('managementCustomer.optionalLabel'),
            optional: true,
            class: "w-full mr-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                id: "input_catatan_tambah-pelanggan",
                type: "input",
                modelValue: _ctx.note,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.note = $event)),
                preventEnterTextArea: true,
                format: _ctx.replaceNewLine,
                placeholder: _ctx.$t('managementCustomer.placeholder.note'),
                error: !!_ctx.errorNotes,
                "error-caption": _ctx.errorNotes,
                onFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setFieldIndex(5)))
              }, null, 8, ["modelValue", "format", "placeholder", "error", "error-caption"])
            ]),
            _: 1
          }, 8, ["label", "suffix"])
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode(_component_Tabs, {
            modelValue: _ctx.activeTab,
            data: _ctx.tabs,
            rounded: false,
            marginTop: "0",
            "onUpdate:modelValue": _ctx.onChangeTab
          }, null, 8, ["modelValue", "data", "onUpdate:modelValue"]),
          (_ctx.activeTab === 'alamat')
            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('managementCustomer.form.address'),
                    class: "w-full mr-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        type: "textarea",
                        modelValue: _ctx.address,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.address = $event)),
                        preventEnterTextArea: true,
                        error: _ctx.errorMandatory[5] && !!_ctx.errorAddress,
                        "error-caption": _ctx.errorAddress,
                        format: _ctx.replaceNewLine,
                        placeholder: _ctx.$t('managementCustomer.placeholder.address'),
                        onFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setFieldIndex(6)))
                      }, null, 8, ["modelValue", "error", "error-caption", "format", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('managementCustomer.form.district'),
                      suffix: _ctx.$t('managementCustomer.optionalLabel'),
                      class: "w-full mr-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SelectSearch, {
                          class: "mt-2",
                          onFilter: _ctx.fetchdestinationCity,
                          isLoading: _ctx.isLoadingdestinationCity,
                          options: _ctx.destinationCityList,
                          keyName: "name",
                          keyValue: "id",
                          placeholder: _ctx.$t('managementCustomer.placeholder.district'),
                          modelValue: _ctx.destinationCity,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.destinationCity = $event)),
                          onFocus: _ctx.onFocusdestinationCity,
                          onChange: _ctx.onChangeDestinationCity
                        }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "onFocus", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label", "suffix"])
                  ]),
                  _createVNode("div", _hoisted_30, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('managementCustomer.form.zipCode'),
                      suffix: _ctx.$t('managementCustomer.optionalLabel'),
                      class: "w-full mr-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SelectSearch, {
                          class: "mt-2",
                          onFilter: this.fetchZipCode,
                          onChange: _ctx.onChangeZipCode,
                          isLoading: _ctx.isLoadingZipCode,
                          options: _ctx.zipCodeList,
                          keyName: "name",
                          keyValue: "code",
                          placeholder: _ctx.$t('managementCustomer.placeholder.zipCode'),
                          modelValue: _ctx.zipCode,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.zipCode = $event)),
                          onFocus: _ctx.onFocusZipCode
                        }, null, 8, ["onFilter", "onChange", "isLoading", "options", "placeholder", "modelValue", "onFocus"])
                      ]),
                      _: 1
                    }, 8, ["label", "suffix"])
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('managementCustomer.form.addressType'),
                      suffix: _ctx.$t('managementCustomer.optionalLabel'),
                      class: "w-full mr-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Select, {
                          dataSelect: _ctx.addressTypeData,
                          onOpenSelect: _ctx.onOpenAddressType,
                          onCloseSelect: this.onCloseAddressType,
                          onChooseSelect: _ctx.onSelectAddressType,
                          value: _ctx.addressType,
                          isOpenMenu: _ctx.addressTypeSelect,
                          isDefaultBlack: false,
                          class: "mt-2"
                        }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                      ]),
                      _: 1
                    }, 8, ["label", "suffix"])
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_32, [
                _createVNode("div", _hoisted_33, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.savedPackageDrafts, (pkg, idx) => {
                    return (_openBlock(), _createBlock(_Fragment, {
                      key: pkg.key
                    }, [
                      (pkg.isOpen)
                        ? (_openBlock(), _createBlock(_component_SavedPackageForm, {
                            key: 0,
                            index: idx + 1,
                            modelValue: _ctx.savedPackageDrafts[idx],
                            "onUpdate:modelValue": ($event: any) => (_ctx.savedPackageDrafts[idx] = $event)
                          }, null, 8, ["index", "modelValue", "onUpdate:modelValue"]))
                        : (_openBlock(), _createBlock(_component_SavedPackageRow, {
                            key: 1,
                            index: idx + 1,
                            editable: true,
                            savedPackage: _ctx.toRow(pkg),
                            onEdit: ($event: any) => (_ctx.openSavedPackage(pkg.key)),
                            onDelete: ($event: any) => (_ctx.openDeleteSavedPackageModal(pkg.key))
                          }, null, 8, ["index", "savedPackage", "onEdit", "onDelete"]))
                    ], 64))
                  }), 128))
                ]),
                (_ctx.savedPackageDrafts.length < 3)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "mt-3 flex w-full items-center justify-center gap-1.5 text-sm font-semibold text-red-lp-2400",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.addSavedPackage && _ctx.addSavedPackage(...args)))
                    }, [
                      _hoisted_34,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("managementCustomer.savedPackage.addButton")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerPhoneNumberIdenticalClose,
      title: _ctx.$t('managementCustomer.modalPhoneExistsTitle'),
      message: _ctx.$t('managementCustomer.modalPhoneExistsMessage'),
      image: "badge-exit-confirmation",
      textSuccess: _ctx.$t('managementCustomer.modalPhoneExistsSubmit'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openPhoneNumberIdenticalError]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerDeleteSavedPackage,
      onClose: _ctx.onCloseModalDeleteSavedPackage,
      title: _ctx.$t('managementCustomer.savedPackage.deleteConfirmTitle'),
      message: _ctx.$t('managementCustomer.savedPackage.deleteConfirmMessage'),
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('managementCustomer.savedPackage.deleteConfirmSubmit'),
      textCancel: _ctx.$t('managementCustomer.savedPackage.deleteConfirmCancel'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openModalDeleteSavedPackage]
    ])
  ], 64))
}